

import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'

import { Filter } from '@/_utils/filter'

interface TableSortSetting {
  column: string
  direction: string
}

@Component({
  components: {},
  computed: {},
})
export default class TableSortMixin extends Vue {
  filterUtilTableSort!: any
  tableSortSettings: [string, string] = ['', 'asc']
  private tableRefName: string = ''

  get tableRef(): string {
    return this.tableRefName
  }

  set tableRef(value: string) {
    this.tableRefName = value
  }

  onTableSort(column, direction) {
    this.filterUtilTableSort.save([column, direction])
  }

  toggleCard(row) {
    if (!this.$isMobileSize() || !this.tableRef) {
      return
    }

    const tableRef = this.$refs[this.tableRef] as any
    tableRef.toggleDetails(row)
  }

  collapseCard(row) {
    if (!this.tableRef) {
      return
    }

    // Card will collapse when click to the details (available on Mobile view)
    const tableRef = this.$refs[this.tableRef] as any
    tableRef.closeDetailRow(row)
  }

  beforeMount() {
    this.tableSortSettings = this.filterUtilTableSort?.get() || this.tableSortSettings
  }

  beforeRouteLeave(to: Route, from: Route, next: () => void): void {
    this.tableRef = ''
    next()
  }
}
